import React, { useEffect } from 'react'
import './pricing-page.styles.scss';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import PricingTable from '@/components/SHARED/pricing-table/pricing-table.component';
import UnauthHeader from '@/components/layout-unauth/unauth-head.component';
import Footer from '@/components/layout-unauth/footer/footer.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { Desktop, LargeTablet, Mobile, Tablet } from '@/utils/responsiveQueries';
import UnauthHeaderMobile from '@/components/layout-unauth/unauth-header-mobile.component';
import InfoLinks from '@/components/SHARED/info-links/info-links.component';

const PricingPage = () => {

    useEffect(() => {
        changeDocumentTitle('Gamably | Pricing');
        var r = document.querySelector(':root');
        r.style.setProperty('--primary', '#674fa7');
        r.style.setProperty('--primary-trans', '#674fa7a6');
    }, [])

    return (
        <div className='pricing-page'>
            <Desktop>
                <UnauthLayout>
                <div className='pricing-page-container'>
                    <div className='g-space-2'></div>
                    <PricingTable />
                    <div className='g-space-1'></div>
                    <InfoLinks />
                    <div className='g-space-1'></div>
                </div>
                </UnauthLayout>
            </Desktop>

            <LargeTablet>
                <UnauthLayout >
                <div className='pricing-page-container'>
                    <div className='g-space-2'></div>
                    <PricingTable />
                    <div className='g-space-1'></div>
                    <InfoLinks />
                    <div className='g-space-1'></div>
                </div>
                </UnauthLayout>
            </LargeTablet>

            <Tablet>
                <UnauthLayout>
                <div className='pricing-page-container'>
                    <div className='g-space-2'></div>
                    <PricingTable />
                    <div className='g-space-1'></div>
                    <InfoLinks />
                    <div className='g-space-1'></div>
                </div>
                </UnauthLayout>
            </Tablet>

            <Mobile>
                <UnauthLayout >
                <div className='pricing-page-container'>
                    {/* <div className='g-space-1'></div> */}
                    <PricingTable />
                    <div className='g-space-1'></div>
                    <InfoLinks />
                    <div className='g-space-1'></div>
                </div>
                </UnauthLayout>
            </Mobile>
        </div>
    )
}

export default PricingPage